import React from 'react';
import styled from 'styled-components';

const IndicatorBoxContainer = styled.div`
  padding: 20px;
  border: 1px solid rgba(173, 181, 189, 0.2);
  border-radius: 4px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 20px;
  background-color: ${(props) =>
    props.type === 'WXR' ? props.theme.colors['terra-cotta'] : 'white'};
  color: ${(props) =>
    props.type === 'WXR' ? 'white' : props.theme.colors.dark};

  @media (max-width: 845px) {
    padding: 16px;
    margin-bottom: 16px;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
  }

  .title {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 20px;

    span {
      color: rgba(31, 43, 55, 0.5);
      font-size: 12px;
      margin-left: 5px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      text-transform: uppercase;
    }
  }

  p {
    font-size: 12px;
  }

  .iconContainer {
    margin-left: 10px;
  }

  .wxr-content {
    display: flex;
    height: 100px;

    .title {
      font-size: 22px;
    }

    p {
      font-size: 14px;
    }
  }

  ${(props) => props.styles}
`;

const IndicatorNoteBox = ({ title, content, styles, type }) => {
  return (
    <IndicatorBoxContainer styles={styles} type={type}>
      <div className={type === 'WXR' ? 'wxr-content' : 'other-content'}>
        {type === 'WXR' ? (
          <div>
            <div className="header">
              <div className="title">{title}</div>
            </div>
            {content}
          </div>
        ) : (
          <div>
            <div className="header">
              <div className="title">{title}</div>
            </div>
            {content}
          </div>
        )}
      </div>
    </IndicatorBoxContainer>
  );
};

export default IndicatorNoteBox;
